import axios from 'api';

// /api/super/settings/ — runtime config store. Closest super-admin equivalent
// to the legacy frontend_api/web_config endpoint. Each row: {id, key, value, description, ...}.

export const getWebConfig = () => {
  return axios.get(`/api/super/settings/?page_size=1000`);
};

export const getSettingByKey = (key) => {
  return axios.get(`/api/super/settings/${key}/`);
};
